import { render, staticRenderFns } from "./WFLink.vue?vue&type=template&id=11e5544a&scoped=true"
import script from "./WFLink.vue?vue&type=script&lang=js"
export * from "./WFLink.vue?vue&type=script&lang=js"
import style0 from "./WFLink.vue?vue&type=style&index=0&id=11e5544a&prod&scoped=true&lang=less"
import style1 from "./WFLink.vue?vue&type=style&index=1&id=11e5544a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e5544a",
  null
  
)

export default component.exports